import { atom, useAtomValue } from "jotai";
import {
  SupplyChainFileAction,
  SupplyChainFileType,
} from "../../api/supplyChain/postSupplyChainUpdateFile";

export interface PendingUploadData {
  productId: number;
  fileVersionId?: number;
  supplyChainUploadMetadata: SupplyChainUploadMetadata;
  releaseId?: number;
  scheduledProjectId?: number;
  releaseTrackId?: number;
  projectId?: number | null;
}

export interface SupplyChainUploadMetadata {
  type: SupplyChainFileType;
  action: SupplyChainFileAction;
  id?: number;
  name?: string;
  original_file_name?: string;
  filePath?: string;
}

export interface PendingUploadParams {
  key: string;
  pendingUploadData: PendingUploadData;
}

export interface PendingUploads {
  [key: string]: PendingUploadData;
}

export const supplyChainPendingUploadsAtom = atom<PendingUploads>({});

export const addPendingUploadAtom = atom(
  (get) => get(supplyChainPendingUploadsAtom),
  (get, set, { key, pendingUploadData }: PendingUploadParams) => {
    set(supplyChainPendingUploadsAtom, {
      ...get(supplyChainPendingUploadsAtom),
      [key]: pendingUploadData,
    });
  },
);

export const removePendingUploadAtom = atom(
  (get) => get(supplyChainPendingUploadsAtom),
  (get, set, key: string) => {
    const current = get(supplyChainPendingUploadsAtom);
    const { [key]: _, ...updatedPending } = current;
    set(supplyChainPendingUploadsAtom, updatedPending);
  },
);

export const useGetTrackFileValidationStatus = (releaseTrackId: number) => {
  const pending = useAtomValue(supplyChainPendingUploadsAtom);
  return Object.values(pending).some(
    (pendingData) => pendingData.releaseTrackId === releaseTrackId,
  );
};
